<template>
  <v-app-bar app clipped-right
    class="px-2"
    color="primary blue-grey--text text--darken-4">
    <v-app-bar-nav-icon v-if="$vuetify.breakpoint.mdAndDown" @click="toggleNavigator" class="mr-2"></v-app-bar-nav-icon>
    <v-toolbar-title class="subheading white--text">
    </v-toolbar-title>
    <v-spacer></v-spacer>
    <v-row dense align="center" justify="end">
      <v-col cols="8" class="mr-4">
        <SearchTool />
      </v-col>
    </v-row>
      <RecorderToolkit :className="'primary darken-1 blue-grey--text text--darken-4 mr-2'" />
      <Toolkits />
  </v-app-bar>
</template>

<script>
import Toolkits from './components/toolkits'
import RecorderToolkit from '@/components/recorder'
import SearchTool from './components/toolkits/search'
export default {
  name: 'authorToolbar',
  components: {
    Toolkits,
    RecorderToolkit,
    SearchTool
  },
  data () {
    return {
      config: {
        status: {
          user: false
        }
      }
    }
  },
  methods: {
    toggleNavigator: function () {
      this.$emit('emit', {
        dest: 'navigator',
        action: 'toggle',
        data: null
      })
    },
    develop: function (status) {
      this.$store.commit('author/develop', status)
    },
    logout: function () {
      this.$router.push('/logout')
    }
  },
  computed: {
    printAuthorName () {
      return this.$store.getters['author/get']('name').join(' ')
    },
    isDeveloper () {
      let roles = this.$store.getters['author/get']('roles')
      return roles.includes('developer')
    },
    isDeveloping () {
      return this.$store.getters['author/get']('dev')
    }
  }
}
</script>
